(() => {
  function scoreLink(link) {
    const raw = link.getAttribute('href')?.trim();
    if (!raw || raw.startsWith('#')) return -1;
    const current = new URL(location.href), candidate = new URL(link.href, location.href);
    if (candidate.origin !== current.origin || candidate.pathname.replace(/\/$/, '') !== current.pathname.replace(/\/$/, '')) return -1;
    let count = 0;
    for (const [key, value] of candidate.searchParams) {
      if (['preview_theme_id', '_bt', 'oseid', 'pb', 'page'].includes(key)) continue;
      if (!current.searchParams.getAll(key).includes(value)) return -1;
      count += 1;
    }
    return count;
  }
  function syncHeader() {
    const roots = [...document.querySelectorAll('[data-tf-nav-root]')];
    const native = roots.filter(root => root.dataset.tfNativeActive === 'true');
    let selected = roots.find(root => {
      const link = root.querySelector(':scope > a[href]');
      return link && scoreLink(link) >= 0;
    }) || native[0];
    const collectionHandle = document.querySelector('.tf-collection-heading')?.dataset.tfCollectionHandle;
    if (!selected && collectionHandle && collectionHandle !== 'all') selected = roots.find(root => (root.dataset.tfNavCollections || '').split('|').includes(collectionHandle));
    const activeTab = document.querySelector('.tf-collection-tab.is-active');
    if (!selected && activeTab) selected = roots.find(root => [...root.querySelectorAll('a[href]')].some(link => link.href === activeTab.href));
    if (!selected) {
      let best = -1;
      roots.forEach(root => root.querySelectorAll('a[href]').forEach(link => {
        const score = scoreLink(link);
        if (score > best) { best = score; selected = root; }
      }));
    }
    roots.forEach(root => {
      const active = root === selected;
      if (root.dataset.tfNavActive !== String(active)) root.dataset.tfNavActive = String(active);
      const trigger = root.querySelector(':scope > a, :scope > details > summary');
      if (!trigger) return;
      if (active) trigger.setAttribute('aria-current', trigger.tagName === 'A' ? 'page' : 'true');
      else trigger.removeAttribute('aria-current');
    });
  }
  function syncCollection() {
    const heading = document.querySelector('.tf-collection-heading'), tabs = [...document.querySelectorAll('.tf-collection-tab')];
    if (!heading || !tabs.length) return; // Native category facet states already come from Shopify.
    let selected, best = -1;
    tabs.forEach(tab => {
      let score = scoreLink(tab);
      const normalizeTitle = value => (value || '').toLowerCase().replace(/[^a-z0-9\u0600-\u06ff]/g, '');
      const matchesCollection = tab.dataset.tfCollectionOriginal === heading.dataset.tfCollectionHandle || normalizeTitle(tab.dataset.tfCollectionLabel) === normalizeTitle(heading.dataset.tfCollectionTitle);
      if (score < 0 && heading.dataset.tfCollectionHandle !== 'all' && matchesCollection && new URL(tab.href, location.href).pathname !== location.pathname) score = 0;
      if (score > best) { best = score; selected = tab; }
    });
    tabs.forEach(tab => {
      tab.classList.toggle('is-active', tab === selected);
      if (tab === selected) tab.setAttribute('aria-current', 'page'); else tab.removeAttribute('aria-current');
    });
    const title = heading.dataset.tfCollectionHandle === 'all' ? (selected?.dataset.tfCollectionLabel || 'All Products') : heading.dataset.tfCollectionTitle;
    const h1 = heading.querySelector('h1');
    if (!title || !h1 || h1.textContent.trim().replace(/\s+/g, ' ') === title) return;
    const words = title.trim().split(/\s+/), last = words.pop();
    h1.replaceChildren();
    if (words.length) { h1.append(document.createTextNode(words.join(' ') + ' ')); const emphasis = document.createElement('em'); emphasis.textContent = last; h1.append(emphasis); }
    else h1.textContent = last;
  }
  function sync() { syncCollection(); syncHeader(); }
  sync();
  window.addEventListener('popstate', sync);
  document.addEventListener('shopify:section:load', sync);
  const main = document.querySelector('#MainContent');
  if (main) {
    let frame;
    new MutationObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }).observe(main, {childList:true,subtree:true});
  }
})();
